import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/teacher-subject-codes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/teacher-subject-codes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/teacher-subject-codes/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/teacher-subject-codes/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const subject = teacher_id => {
  return httpClient
    .get('/api/teacher-subject-codes/subjects', {
      params: { teacher_id: teacher_id }
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  update,
  destroy,
  subject
}
